import * as React from 'react';
import * as Yup from 'yup';
import {Formik, FormikProps} from 'formik';
import FormBase, {FormValues} from './private/ChatFormBase';
import {ChatChannel} from '../../models/chatChannelModel';

interface ChatFormProps {
  channel?: ChatChannel;
}

export default class ChatForm extends React.Component<ChatFormProps, {}> {
  public render() {
    return (
      <Formik
        initialValues={{message: ''}}
        validationSchema={this._validationSchema}
        onSubmit={this._handleSubmit}
        render={(props: FormikProps<FormValues>) => <FormBase {...props} />}
      />
    );
  }

  private get _validationSchema() {
    return Yup.object().shape({
      message: Yup.string().required('Please enter a message.')
    });
  }

  private _handleSubmit = ({message}: FormValues, {resetForm}: {resetForm: () => void}) => {
    const {channel} = this.props;

    if (channel) {
      channel.sendTextMessage(message);
      resetForm();
    }
  };
}



// WEBPACK FOOTER //
// ./src/containers/ChatForm/ChatForm.tsx